import enMessages from './messages/en.json';
import csMessages from './messages/cs.json';
import enVocabulary from './messages/en-vocabulary.json';
import csVocabulary from './messages/cs-vocabulary.json';
import { Locale } from './locale';

export type MessageCatalog = Record<string, string>;

export const messages: Record<Locale, MessageCatalog> = {
  en: { ...enMessages, ...enVocabulary },
  cs: { ...csMessages, ...csVocabulary },
};
